import React from 'react';
import * as SC from './contentCentered.styled';
import { ColorTheme } from '../utils/colorTheme';
import { Container } from '../common';

interface ContentCenteredProps {
    content?: React.ReactElement;
    theme?: ColorTheme;
}

const ContentCentered: React.FC<ContentCenteredProps> = (props) => {
    const { content, theme } = props;
    return (
        <SC.Banner theme={theme}>
            <Container>
                {content}
            </Container>
        </SC.Banner>
    )
}

export default ContentCentered;